import type { AnamnesisTemplate } from './types';

export const ADULTO_TEMPLATE: AnamnesisTemplate = {
    id: 'adulto',
    name: 'Anamnese adulto',
    sections: [
        {
            title: 'Identificação',
            questions: [
                'Estado civil e com quem reside?',
                'Profissão e situação de trabalho atual?',
                'Quem encaminhou ou indicou?',
            ],
        },
        {
            title: 'Queixa principal',
            questions: [
                'O que motivou a busca por atendimento?',
                'Quando os sintomas ou dificuldades começaram?',
                'Por que buscar ajuda agora?',
                'Como isso afeta o dia a dia?',
            ],
        },
        {
            title: 'História da queixa atual',
            questions: [
                'Como a queixa evoluiu desde o início?',
                'Existem fatores que desencadeiam, pioram ou aliviam?',
                'Já houve períodos de melhora?',
                'Já fez tratamento para isso antes (psicoterapia, medicação)?',
            ],
        },
        {
            title: 'Histórico de saúde e tratamentos',
            questions: [
                'Doenças ou condições médicas relevantes?',
                'Medicações em uso (nome e dose, se souber)?',
                'Internações ou cirurgias?',
                'Uso de álcool, tabaco ou outras substâncias?',
            ],
        },
        {
            title: 'História familiar',
            questions: [
                'Como é a composição e a dinâmica da família?',
                'Histórico de transtornos mentais, uso de substâncias ou suicídio na família?',
                'Como eram as relações na família de origem?',
            ],
        },
        {
            title: 'História pessoal',
            questions: [
                'Como foi a infância e a adolescência?',
                'Trajetória escolar e profissional?',
                'Relacionamentos afetivos significativos?',
                'Eventos marcantes (perdas, mudanças, violências)?',
            ],
        },
        {
            title: 'Sono, alimentação e rotina',
            questions: [
                'Como está o sono (dificuldade para dormir, despertares, qualidade)?',
                'Como está o apetite e a alimentação?',
                'Pratica atividade física ou de lazer?',
                'Como é um dia típico?',
            ],
        },
        {
            title: 'Vida social e rede de apoio',
            questions: [
                'Com quem pode contar nos momentos difíceis?',
                'Como está a vida social e as amizades?',
                'Participa de grupos, comunidade ou atividades religiosas?',
            ],
        },
        {
            title: 'Expectativas e objetivos terapêuticos',
            questions: [
                'O que espera do processo terapêutico?',
                'O que gostaria que estivesse diferente ao final?',
                'Já definiu alguma meta inicial?',
            ],
        },
    ],
};
